
// @ts-nocheck





import { i18nText } from '@/locales';


    import { Component } from "vue-property-decorator";
    import { Modal } from "ant-design-vue";
    import { mixins } from "vue-class-component";

    import { SimpleProxyForm } from "@/UI/components/Helpers/SimpleProxyForm";
    import { VisitsStore } from "@/store/modules/Visits";
    import { DateTime } from "ts-luxon";
    import { UtilsMix } from "@/UI/pages/visitsNew/mixins/UtilsMix"
    import Api from '@/repository/api';


    @Component({
        components: {
            "a-modal": Modal,
        },
    })
    
    export default class DebtForm extends mixins( SimpleProxyForm, UtilsMix) {
        showModal: boolean = false;
        vData: any[] = [];
        id = this.$router.currentRoute.params["id"];

        showStatus(status: number): string | undefined {
            if (status === 1) return i18nText("ожидание");
            if (status === 2) return i18nText("пришел");
            if (status === 3) return i18nText("не пришел");
            if (status === 4) return i18nText("подтвердил");
        }

        showDateFormat(date: string): string {
            const startVisit = DateTime.fromSQL(date as string).toLocal();
            return startVisit.toLocaleString(DateTime.DATE_SHORT);
        }
        async modalCancel(): Promise<void> {
            this.showModal = false;
            await this.backToRoute(0);
        }
        async modalOk(): Promise<void> {
            this.showModal = false;
            await this.backToRoute(0);
        }


        async getData(): Promise<void> {
            console.log('++++++++++++++++++++1676999945++++++++++++++++++++++++');console.log('this.client : ' + (typeof this.client));console.log(this.client);console.log('--------------------1676999945------------------------');



            let data = {client_id: 1};
            const response = await Api.get(`/clients/debts/get`, {
                params: data,
                paramsSerializer: function paramsSerializer(params) {
                    return new URLSearchParams(params).toString();
                },
            });
            console.log('++++++++++++++++++++1676996880++++++++++++++++++++++++');console.log('response : ' + (typeof response));console.log(response);console.log('--------------------1676996880------------------------');

            this.vData = response.data;
            console.log('++++++++++++++++++++1677000519++++++++++++++++++++++++');console.log('response.data.filter(e => e.basket.products.length > 0) : ' + (typeof response.data.filter(e => e.basket.products.length > 0)));console.log(response.data.filter(e => e.basket.products.length > 0));console.log('--------------------1677000519------------------------');


            // this.client?.visits.map(async (visit: any) => {
            //     await VisitsStore.fetchData({ filter: { id: visit["id"] } });
            //     this.vData.push(this.visit);
            // });
        }

        async setShow(): Promise<void> {
            this.showModal = true;
        }
        async created(): Promise<void> {
            try {
                await this.getData();
            } finally {
                await this.setShow();
            }
        }
    }
